import { useNavigate } from "react-router";

export default function Fitness() {
    const beforeAfterImages = [
        { src: "/images/before.jpeg", label: "Before" }, 
        { src: "/images/after.jpeg", label: "After" }, 
    ];
    const navigate = useNavigate()
    return (
        <div
            style={{
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                maxWidth: "900px",
                margin: "50px auto",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#0d9f7d",
                    marginBottom: "20px",
                }}
            >
                My Fitness Journey
            </h2>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                At my heaviest, I weighed 110 kilograms (242 pounds).
                Over the course of a year, I embarked on a transformative journey, losing 
                30 kilograms (66 pounds). This was more than just a
                physical change, it was a complete lifestyle shift. I started eating
                healthy, exercising regularly, and discovered the importance of balancing
                a peaceful mind with a healthy body.
            </p>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                Throughout this journey, I learned invaluable lessons about myself, my
                limits, and how to treat my body and mind with care and respect. This
                transformation didn't just affect my physical appearance, it positively
                influenced my confidence, social skills, work ethic, and even my studies.
                A healthier, happier version of myself emerged, and it has impacted every
                area of my life for the better. It also taught me discipline and organization,
                which I use in my daily life to manage my time effectively, set goals, and stay focused.
                A peaceful mind and a healthy body go hand in hand. Through fitness, I
                found not only strength but also a new sense of confidence and purpose.
            </p>


            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                    marginTop: "30px",
                    flexWrap: "wrap",
                }}
            >
                {beforeAfterImages.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            textAlign: "center",
                            borderRadius: "10px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                            overflow: "hidden",
                            width: "250px",
                        }}
                    >
                        <img
                            src={image.src}
                            alt={`${image.label} Image`}
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                            }}
                        />
                        <p
                            style={{
                                marginTop: "10px",
                                fontWeight: "bold",
                                color: "#555",
                            }}
                        >
                            {image.label}
                        </p>
                    </div>
                ))}
            </div>



            <div className="mt-3">
                <button
                    onClick={() => navigate("/Rayan/Home")} 
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#0d9f7d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
}
